import React from 'react';
import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import Divider from '@mui/material/Divider';
import { AcademicRequirementConstant, EnglishExamRequirement, ExamRequirements } from './common/constant';
import InformationCard from './common/InformationCard';
import ShowMoreText from './common/ShowMoreText';
import Title from './common/Title';
var StyledTableCell = styled(TableCell)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(tableCellClasses.head)] = {
            fontWeight: 'bolder',
            fontSize: 16,
            border: '0.1px solid gray',
            borderLeft: 0,
            borderRight: 0
        },
        _b["&.".concat(tableCellClasses.body)] = {
            fontSize: 16,
            fontWeight: 'bold',
            border: '0.1px solid gray',
            borderLeft: 0,
            borderRight: 0
        },
        _b);
});
var StyledTableRow = styled(TableRow)(function (_a) {
    var theme = _a.theme;
    return ({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover
        },
        '&:last-child td, &:last-child th': {
            borderBottom: 0
        }
    });
});
var EligiblityRequirements = function (_a) {
    var _b;
    var courseData = _a.courseData, eligibilityHeaderRef = _a.eligibilityHeaderRef, aboutCourseRef = _a.aboutCourseRef, onShowMoreClick = _a.onShowMoreClick;
    return (React.createElement("div", { className: "lfc-bg-white lfc-rounded-lg lfc-p-6", ref: eligibilityHeaderRef },
        React.createElement("div", { className: "lfc-flex lfc-items-center lfc-mb-4" },
            React.createElement("div", { className: "lfc-text-2xl lfc-font-semibold lfc-mr-2" }, " Eligibility Requirements ")),
        (courseData === null || courseData === void 0 ? void 0 : courseData.mainEntryRequirements) ? (React.createElement("div", { className: "lfc-bg-violet-1010 lfc-p-4 lfc-my-4" },
            React.createElement("div", { className: "lfc-flex lfc-text-xl lfc-text-blue-150 lfc-mb-3 lfc-font-semibold" },
                React.createElement("img", { src: '/assets/icons/course-finder/star-cf.svg', alt: 'star' }),
                React.createElement("div", { className: "lfc-ml-2" }, " Main Entry Requirements")),
            React.createElement(ShowMoreText, { text: courseData === null || courseData === void 0 ? void 0 : courseData.mainEntryRequirements, maximumNoOfwords: 450, section: 'Main Entry Requirements', data: courseData, onShowMoreClick: onShowMoreClick }))) : (React.createElement(React.Fragment, null)),
        React.createElement(Divider, null),
        React.createElement(Title, { title: 'Academic Requirement' }),
        React.createElement(InformationCard, { cardData: AcademicRequirementConstant(courseData), gridCol: 2, bgColor: false, imgHeight: 40, imgWidth: 40, courseData: courseData }),
        React.createElement(Divider, null),
        React.createElement(Title, { title: 'English Exam Requirement' }),
        React.createElement("div", { className: "lfc-my-4" },
            React.createElement(TableContainer, { component: Paper },
                React.createElement(Table, { size: "medium", "aria-label": "a dense table" },
                    React.createElement(TableHead, { sx: { backgroundColor: '#F5F4FF' } },
                        React.createElement(StyledTableRow, null,
                            React.createElement(StyledTableCell, null, "English Exam"),
                            React.createElement(StyledTableCell, null, "Overall"),
                            React.createElement(StyledTableCell, null, "No less than"))),
                    React.createElement(TableBody, null, (_b = EnglishExamRequirement(courseData)) === null || _b === void 0 ? void 0 : _b.map(function (row, index) { return (React.createElement(StyledTableRow, { className: "lfc-cursor-pointer", key: index },
                        React.createElement(StyledTableCell, { component: "th", scope: "row" }, row.name),
                        React.createElement(StyledTableCell, null, row.overall),
                        React.createElement(StyledTableCell, null, row.nolessThan))); }))))),
        React.createElement(Divider, null),
        React.createElement(Title, { title: "Additional Requirement" }),
        React.createElement("div", { ref: aboutCourseRef },
            React.createElement(InformationCard, { cardData: ExamRequirements(courseData), gridCol: 2, bgColor: false, imgHeight: 40, imgWidth: 40, courseData: courseData })),
        React.createElement(Divider, null)));
};
export default EligiblityRequirements;
//# sourceMappingURL=EligiblityRequirements.js.map